import React, { useState } from 'react'
import { create as ipfsHttpClient } from 'ipfs-http-client'
const ipfs = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0')

export const PdfUpload = ({ setUrl }) => {
    const [pdf, setPdf] = useState({})
    const [pdfPreview, setPdfPreview] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploaded, setUploaded] = useState(false)

    const createPreview = (e) => {
        if (e.target.value !== '') {
            setPdf(e.target.files[0])
            const src = URL.createObjectURL(e.target.files[0])
            setPdfPreview(src)
        } else {
            setPdfPreview('')
        }
    }

    const uploadFile = async (e) => {
        setLoading(true)
        e.preventDefault()

        try {
            const added = await ipfs.add(pdf)
            const url = `https://ipfs.infura.io/ipfs/${added.path}`
            setPdfPreview(url)
            setUrl(url)
            setUploaded(true)
        } catch (err) {
            console.log('Error uploading the file : ', err)
        }
        setLoading(false)
    }

    const previewAndUploadButton = () => {
        if (pdfPreview !== '') {
            if (!loading) {
                return (
                    <div>
                        {uploaded ? (
                            <h5>
                                ✅{' '}
                                <a
                                    href={pdfPreview}
                                    s
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    PDF
                                </a>{' '}
                                Uploaded Successfully ✅
                            </h5>
                        ) : (
                            <div className='mt-3'>
                                <button type='submit' className='inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md border border-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>
                                    Upload PDF
                                </button>
                                
                                <h5 className='mt-3 mb-3'>
                                    {pdf.name} <span className='bg-green-100 text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
                                        {pdf.size} kb</span>
                                </h5>

                                <embed
                                    width='75%'
                                    height='400px'
                                    className='mb-3'
                                    src={pdfPreview}
                                ></embed>
                            </div>
                        )}
                    </div>
                )
            } else {
                return (
                    <div className="grid grid-cols-1 gap-y-6 mt-4 sm:grid-cols-3 sm:gap-x-4">
                        <h4>Uploading PDF</h4>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                            <div className="bg-blue-600 h-2.5 rounded-full" style="width: 69%"></div>
                        </div>
                        <h4>Please Wait ...</h4>
                    </div>
                )
            }
        }
    }

    return (
        <div>
            <form onSubmit={uploadFile}>
                <input
                    required
                    type='file'
                    accept='application/pdf'
                    onChange={(e) => createPreview(e)}
                    className='p-3 text-sm bg-white rounded border-0 focus:outline-none focus:ring shadow transition-all duration-150 ease-linear placeholder:text-blueGray-300 text-blueGray-600'
                />

                {previewAndUploadButton()}
            </form>
        </div>
    )
}
